import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";

export default function EnquireDialog({ trigger, productName = "", testId = "enquire-dialog" }) {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error(t("contact_page.form_error_required"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/enquiries", { ...form, product: productName });
      toast.success(t("contact_page.form_success"));
      setForm({ name: "", phone: "", email: "", message: "" });
      setOpen(false);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild data-testid={`${testId}-trigger`}>{trigger}</DialogTrigger>
      <DialogContent data-testid={`${testId}-content`} className="bg-ivory border-dust max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-forest">{t("products_page.enquire_dialog_title")} {productName}</DialogTitle>
          <DialogDescription className="text-ink/70">{t("products_page.enquire_dialog_desc")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <Label htmlFor="enq-name">{t("common.name")} *</Label>
            <Input id="enq-name" data-testid="enquire-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-white border-dust mt-1" />
          </div>
          <div>
            <Label htmlFor="enq-phone">{t("common.whatsapp")} *</Label>
            <Input id="enq-phone" data-testid="enquire-phone-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="bg-white border-dust mt-1" />
          </div>
          <div>
            <Label htmlFor="enq-email">{t("common.email")}</Label>
            <Input id="enq-email" data-testid="enquire-email-input" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-white border-dust mt-1" />
          </div>
          <div>
            <Label htmlFor="enq-msg">{t("common.message")}</Label>
            <Textarea id="enq-msg" data-testid="enquire-message-input" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="bg-white border-dust mt-1" rows={3} />
          </div>
          <DialogFooter>
            <button type="submit" data-testid="enquire-submit-btn" className="btn-pill btn-terra w-full justify-center" disabled={loading}>
              {loading ? t("common.sending") : t("common.send")}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
